export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11116.484506b5.jpg";